import defaultState from "./state";

const filtroBusquedaRAReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "RA/CARGA_ARANCELES_DETALLE": {
      return Object.assign({}, state, {
        arancelesDetalle: action.arancelesDetalle,
        busquedaarancelesDetalle: true,
        infoExpanded: true,
        loading: false,
      });
    }

    case "RA/LOADING": {
      return Object.assign({}, state, {
        loading: action.loading,
      });
    }

    case "RA/LOADINGARANCELCOMPLETO": {
      return Object.assign({}, state, {
        loadingFileArancelCompleto: action.loadingFileArancelCompleto
      })
    }

    case "RA/LOADINGARANCELSELECCIONADO": {
      return Object.assign({}, state, {
        loadingFileArancelSeleccionado: action.loadingFileArancelSeleccionado
      })
    }

    case "RA/INFO_EXPANDED": {
      return Object.assign({}, state, {
        infoExpanded: action.infoExpanded,
      });
    }

    case "RA/CARGA_HISTORIAL_REAJUSTES": {
      return Object.assign({}, state, {
        historialReajustes: action.historialReajustes,
      });
    }

    case "RA/CARGA_PERIODO_REAJUSTE": {
      const periodoReajuste = Object.assign({}, state.periodoReajuste, {
        FechaInicio: action.periodoReajuste.FECHAINICIO,
        FechaTermino: action.periodoReajuste.FECHATERMINO,
        ValorReajuste: action.periodoReajuste.VALORREAJUSTE,
        Validado: action.periodoReajuste.VALIDADO === 1,
        PeriocidadUnidad: action.periodoReajuste.PERIOCIDADUNIDAD,
        Observacion: action.periodoReajuste.OBSERVACION,
        ValidoArancel: action.periodoReajuste.VALIDOARANCEL,
        //ValidoPaquetes: action.periodoReajuste.VALIDOPAQUETES,
        //ValidoGes: action.periodoReajuste.VALIDOGES,
      });

      return Object.assign({}, state, {
        periodoReajuste,
      });
    }

    case "RA/CARGA_PERIODO_REAJUSTE_PQ": {
      const periodoReajustePQ = Object.assign({}, state.periodoReajustePQ, {
        FechaInicio: action.periodoReajustePQ.FECHAINICIO,
        FechaTermino: action.periodoReajustePQ.FECHATERMINO,
        ValorReajuste: action.periodoReajustePQ.VALORREAJUSTE,
        Validado: action.periodoReajustePQ.VALIDADO === 1,
        PeriocidadUnidad: action.periodoReajustePQ.PERIOCIDADUNIDAD,
        Observacion: action.periodoReajustePQ.OBSERVACION,
        //ValidoArancel: action.periodoReajustePQ.VALIDOARANCEL,
        ValidoPaquetes: action.periodoReajustePQ.VALIDOPAQUETES,
        //ValidoGes: action.periodoReajustePQ.VALIDOGES,
      });

      return Object.assign({}, state, {
        periodoReajustePQ,
      });
    }

    case "RA/CAMBIAR_FECHA_VIGENCIA_CONSULTA_PERIODO": {
      const periodoReajuste = Object.assign({}, state.periodoReajuste, {
        FechaVigencia: action.valor,
        FechaVigenciaError: action.error,
      });

      return Object.assign({}, state, {
        periodoReajuste,
      });
    }

    case "RA/SET_SOLICITUD_EN_CURSO": {
      return Object.assign({}, state, {
        solicitudEnCurso: action.solicitudEnCurso,
      });
    }

    default:
      return state;
  }
};

export default filtroBusquedaRAReducer;



// WEBPACK FOOTER //
// ./src/components/ReajustarArancel/FiltroBusqueda/reducer.js